import React from 'react';
import PropTypes from 'prop-types';
import createStyles from "../createStyles";
import Option from "./Option";

var getValueFromOption = function getValueFromOption(option) {
  var _option$props;

  return option === null || option === void 0 ? void 0 : (_option$props = option.props) === null || _option$props === void 0 ? void 0 : _option$props.value;
};

var useStyles = createStyles(function (theme) {
  return {
    root: {
      position: 'sticky',
      borderBottom: "1px solid ".concat(theme.palette.placeholder, "70"),
      borderRadius: 0
    }
  };
});
var SelectAllOption = /*#__PURE__*/React.forwardRef(function SelectAllOption(_ref, ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$selectedOptions = _ref.selectedOptions,
      selectedOptions = _ref$selectedOptions === void 0 ? [] : _ref$selectedOptions,
      onChange = _ref.onChange;
  var classes = useStyles();
  var someSelected = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 0;
  var allSelected = someSelected && (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) === options.length;
  var onlySomeSelected = someSelected && !allSelected;

  var handleSelectAllClick = function handleSelectAllClick(e) {
    if (allSelected) {
      onChange(e, []);
    } else {
      var values = options.map(getValueFromOption);
      onChange(e, values);
    }
  };

  var label = allSelected ? 'Unselect all' : 'Select all';
  if (!options.length) return null;
  return /*#__PURE__*/React.createElement(Option, {
    multiselect: true,
    value: "null",
    onClick: handleSelectAllClick,
    selected: allSelected,
    indeterminate: onlySomeSelected,
    className: classes.root,
    ref: ref
  }, label, " ", options.length);
});
SelectAllOption.propTypes = {
  options: PropTypes.arrayOf(PropTypes.node),
  selectedOptions: PropTypes.array,
  onChange: PropTypes.func.isRequired
};
SelectAllOption.displayName = 'SelectAllOption';
export default SelectAllOption;